export default __webpack_public_path__ + "static/media/X_Old_White.aed9c5d0.png";